$.fn.CheckoutAccordion = function() {
  let self = this;
  if (self.data('checkout-accordion') != undefined) {
    return self.data('checkout-accordion')
  }
  let addresses = self.find('#billing_email').closest('.js-accordion__item')
  let shipping = self.find('input.shipping_method').closest('.js-accordion__item')
  self.addClass('checkout-accordion')
  let scroll_timeout;

  // create separate toggles
  self.find('.js-accordion__header').each(function() {
    $(this).after($(this).clone().addClass('--cloned').removeAttr('id'))
  })

  // Open first element
  self.find('.accordion__item:first-child .accordion__header').attr('aria-expanded', 'true');
  self.find('.accordion__item:first-child .js-accordion__panel').css('max-height', 'none').attr('aria-hidden', 'false');
  self.find('.accordion__item:first-child').addClass('--selected')

  // Add summary edit button
  self.find('.js-accordion__item').each(function() {
    if ($('html').attr('lang') == 'fr-CA') {
      var edit_label = 'Modifier'
    } else {
      var edit_label = 'Edit'
    }
    $(this).append('<button class="js-accordion__edit">' + edit_label + '</button>');
  })

  // Edit Section
  self.find('.js-accordion__edit').click(function() {
    var accordion = $(this).closest('.js-accordion__item')

    // Force user to review shipping after editing addresses
    if (accordion.is(':first-child')) {
      accordion.next('.js-accordion__item').removeClass('--completed')
    }

    accordion.find('.js-accordion__header:not(.--cloned)').click()

    return false;
  })

  self.update_billing_summary = function(accordion) {
    var summary = ''
    if (addresses.find('#ship-to-different-address-checkbox').is(':checked')) {
      if ($('html').attr('lang') == 'fr-CA') {
        var billing_label = 'Facturation'
        var shipping_label = 'Livraison'
      } else {
        var billing_label = 'Billing'
        var shipping_label = 'Shipping'
      }
      summary += '<div class="col-1">';
      summary += '<p><strong>'
      + billing_label
      + '</strong>'
      + accordion.find('#billing_first_name').val() + ' '
      + accordion.find('#billing_last_name').val() + '<br/>'
      + accordion.find('#billing_address_1').val()
      + '<br/>'
      + accordion.find('#billing_city').val() + ', '
      + accordion.find('#billing_state').val() + ', '
      + accordion.find('#billing_country').val() + ', '
      + accordion.find('#billing_postcode').val()
      + '<br/>'
      + accordion.find('#billing_email').val()
      + '</p>';
      summary += '</div>';
      summary += '<div class="col-2">';
      summary += '<p><strong>'
      + shipping_label
      + '</strong>'
      + accordion.find('#shipping_first_name').val() + ' '
      + accordion.find('#shipping_last_name').val()
      + '<br/>'
      + accordion.find('#shipping_address_1').val()
      + '<br/>'
      + accordion.find('#shipping_city').val() + ', '
      + accordion.find('#shipping_state').val() + ', '
      + accordion.find('#shipping_country').val() + ', '
      + accordion.find('#shipping_postcode').val()
      + '</p>';
      summary += '</div>';
    } else {
      summary += '<div class="col-1">';
      summary += '<p><strong>'
      + accordion.find('#billing_first_name').val() + ' '
      + accordion.find('#billing_last_name').val()
      + '</strong><br/>'
      + accordion.find('#billing_email').val() + '</p>';
      summary += '<p>'
      + accordion.find('#order_comments').val() + '</p>';
      summary += '</div>';

      summary += '<div class="col-2">';
      summary += '<p>'
      + accordion.find('#billing_address_1').val()
      + '<br/>'
      + accordion.find('#billing_city').val() + ', '
      + accordion.find('#billing_state').val() + ', '
      + accordion.find('#billing_country').val() + ', '
      + accordion.find('#billing_postcode').val()
      + '</p>';
      summary += '</div>';
    }
    return summary
  }

  self.update_shipping_summary = function(accordion) {
    var summary = ''
    var li = $('input.shipping_method:checked').closest('li')
    summary += '<div class="col-1">'
    summary += '<p><strong>'
    if (li.find('.delivery-real-title').length && li.find('.delivery-real-title').html() != '') {
      summary += li.find('.delivery-real-title').html()
    } else if (li.find('.delivery-title').length && li.find('.delivery-title').html() != '') {
      summary += li.find('.delivery-title').html()
    }
    if (li.find('.woocommerce-Price-amount').length && li.find('.woocommerce-Price-amount').html() != '') {
      summary += '<br/>' + li.find('.woocommerce-Price-amount').html()
    } else if (li.find('.delivery-title').length && li.find('.delivery-title').html() != '') {
      if (li.find('.delivery-title').html().includes("gratuit")) {
        summary += '<br/>' + gourmetsauvage_params.free
      }
    }
    summary += '</strong></p>'
    summary += '</div>'
    summary += '<div class="col-2">'
    summary += '<p>'
    if (li.find('.delivery-delay').length && li.find('.delivery-delay').html() != '') {
      summary += '<strong>' + li.find('.delivery-delay').html() + '</strong>'
    }
    if (li.find('.delivery-estimate').length && li.find('.delivery-estimate').html() != '') {
      summary +=  li.find('.delivery-estimate').html()
    }
    if (self.find('input[name="card_for_pickup"]').length) {
      if (self.find('input[name="card_for_pickup"]').prop('checked')) {
        summary += '<br /><small>' + gourmetsauvage_params.cfp + '</small>';
      }
    }
    summary += '</p>'
    summary += '</div>'
    return summary
  }

  //Make accordions work again
  self.find('.js-accordion__header.--cloned').click(function() {
    if ($(this).closest('.js-accordion__item').prev('.js-accordion__item').length) {
      $(this).closest('.js-accordion__item').prev('.js-accordion__item').find('.js-accordion__next').click()
    } else {
      $(this).closest('.js-accordion__item').find('.js-accordion__edit').click()
    }
    return false;
  })

  self.find('.js-accordion__header:not(.--cloned)').click(function() {
    self.find('.js-accordion__item').removeClass('--selected')
    $(this).closest('.js-accordion__item').addClass('--selected')
  })

  // Next section
  self.find('.js-accordion__next').click(function() {
    var accordion = $(this).closest('.js-accordion__item')
    if (accordion.find('.js-accordion__summary').length == 0) {
      accordion.find('.accordion__panel-content').prepend('<div class="js-accordion__summary"></div>')
    }

    var summary = ''
    // Billing info
    if (accordion.find('#billing_email').length == 1) {
      summary = self.update_billing_summary(accordion)
    }
    // Shipping
    if (accordion.find('#shipping_method').length == 1) {
      summary = self.update_shipping_summary(accordion)
    }

    accordion.find('.js-accordion__summary').html(summary)
    accordion.find('.js-accordion__panel').css('--completed-height', accordion.find('.js-accordion__summary').outerHeight() + 'px')
    accordion.addClass('--completed');
    accordion.next('.js-accordion__item').find('.js-accordion__header:not(.--cloned)').click()
    if (scroll_timeout) {
      clearTimeout(scroll_timeout);
    }
    scroll_timeout = setTimeout(() => {
      var scrollTarget = accordion.offset().top - $('.header').outerHeight(false) - 30
      $('body, html').scrollTo(scrollTarget)

    }, 200);
    return false;
  })

  addresses.find('input').on("change keyup click", function() {
    self.validateAddresses()
  });

  addresses.find('#ship-to-different-address-checkbox').on("click", function() {
    self.validateAddresses()
    addresses.find('.js-accordion__panel').css('max-height', 'none');
  });

  self.validateAddresses = function() {
    let validated = true;
    addresses.find('.woocommerce-billing-fields input[aria-required="true"]').each(function () {
      if ($(this).val() == '') {
        validated = false;
      }
    })
    if (addresses.find('#ship-to-different-address-checkbox').is(':checked')) {
      addresses.find('.shipping_address input[aria-required="true"]').each(function () {
        if ($(this).val() == '') {
          validated = false;
        }
      })
    }
    if (validated) {
      addresses.find('.js-accordion__next').addClass('--ready');
      addresses.find('.js-accordion__next').prop('disabled', false);
      addresses.addClass('--validated')
    } else {
      addresses.find('.js-accordion__next').removeClass('--ready');
      addresses.find('.js-accordion__next').prop('disabled', true);
      addresses.removeClass('--validated')
    }
  }
  self.validateAddresses()

  shipping.find("input.shipping_method:checked").on("click", function() {
    self.validateShipping()
  });

  self.validateShipping = function() {
    if (shipping.find("input.shipping_method:checked").val()) {
      shipping.find('.js-accordion__next').addClass('--ready');
      shipping.addClass('--validated')
    } else {
      shipping.find('.js-accordion__next').removeClass('--ready');
      shipping.removeClass('--validated')
    }
  }
  self.validateShipping()

  self.resize = function() {
    $('.js-accordion__summary').each(function() {
      var accordion = $(this).closest('.js-accordion__panel');
      accordion.css('--completed-height', $(this).outerHeight() + 'px')
    })
  }

  // Le contenu des panneaux change après le calcul initial du max-height
  // (formulaire Stripe asynchrone, messages d'erreur) : suivre sa hauteur
  if (window.ResizeObserver) {
    let panel_content_observer = new ResizeObserver(function(entries) {
      entries.forEach(function(entry) {
        let content = $(entry.target)
        let panel = content.closest('.js-accordion__panel')
        if (panel.attr('aria-hidden') === 'false' && panel.css('max-height') !== 'none') {
          let height = content.outerHeight(false)
          if (height > 100) {
            panel.css('max-height', height + 'px')
          }
        }
      })
    })
    self.find('.accordion__panel-content').each(function() {
      panel_content_observer.observe(this)
    })
  }

  return function() {
    self.data('checkout-accordion', self)
    $(window).on('resize orientationchange', self.resize)
    setInterval(function() {
      self.validateAddresses()
    }, 500)
    return self
  }();
};
